/* eslint-disable prefer-rest-params */
const $ = require('jquery')

const APP = require('APP')
const GamePlayBaseView = require('Views/GamePlay/GamePlayBaseView')
const GamePlayHtml5Model = require('Models/GamePlayHtml5Model')

module.exports = GamePlayBaseView.extend({
  aspectRatio: 960 / 640,
  aspectRatioTs: 1024 / 640,
  padding: [46, 0, 0, 0],
  format: 'html',

  initialize() {
    this.modelConstructor = GamePlayHtml5Model
    GamePlayBaseView.prototype.initialize.apply(this, arguments)
  },

  show() {
    GamePlayBaseView.prototype.show.apply(this, arguments)
    this.$el.css('display', '')
  },

  hide() {
    GamePlayBaseView.prototype.hide.apply(this, arguments)
    this.$el.css('display', 'none')
  },

  run(config) {
    GamePlayBaseView.prototype.run.apply(this, arguments)
    window.GAME.run(config.flashvars)
  },

  destroy() {
    const h5rp = this.gameModel.get('html5ReleasePath')

    $(`link[href="${h5rp}/styles/all.css"]`).remove()
    $(`script[src="${h5rp}/require.js"]`).remove()

    if (window.GAME) {
      if (window.GAME.destroy) {
        try {
          window.GAME.destroy()
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err)
        }
      }

      window.GAME.ready = false
    }

    GamePlayBaseView.prototype.destroy.apply(this, arguments)
  },

  getVarsStr() {
    const versions = `v${this.gameModel.get('html5ReleasePath').split('release_')[1]}`

    return versions
  },

  getScreenshot(callback) {
    if (typeof window.GAME.getScreenshot === 'function') {
      window.GAME.getScreenshot(900, 900 / this.aspectRatio, true, 'jpg', (img) => {
        callback(img)

        if (APP.isProvider === true) {
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ screenshot: img }, '*') // router.path('game_popup'));
        }
      })
    } else {
      callback(false)
    }
  },
})
